import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
    /** Segment Analytics.js instance */
    public analytics: any;
}